import { Component, Host, Prop, State, h } from '@stencil/core';
import { type BlogPostPreview } from '../../../types/blog';

@Component({
  tag: 'sy-blog-highlights',
  styleUrl: './scss/index.scss',
  shadow: true,
})
export class SyBlogHighlights {
  /**
   * Highlight post previews
   */
  @Prop() highlights: BlogPostPreview[];

  @State() isSmall = false;

  private carousel: HTMLSyCarouselElement;

  componentDidLoad() {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        this.isSmall = entry.contentRect.width < 950;
      });
    });

    resizeObserver.observe(this.carousel);
  }

  render() {
    return (
      <Host>
        <sy-carousel
          ref={(el: HTMLSyCarouselElement) => (this.carousel = el)}
          loop
          auto-play
          items-visible="1"
          transition-animation="slide"
          auto-play-speed="5000"
          min-size="150"
          preview-side-items-size="0.1"
          slide-by="1"
          transition-duration="20"
          controls-position="around"
          controls-disposition="inside"
          nav-direction="horizontal"
        >
          <sy-indicators slot="indicators" orientation="horizontal"></sy-indicators>
          {!this.isSmall && (
            <sy-button
              slot="prev"
              content="icon-only"
              icon="arrow_back"
              color="secondary"
              variant="filled"
              fab=""
            ></sy-button>
          )}
          {!this.isSmall && (
            <sy-button
              slot="next"
              content="icon-only"
              icon="arrow_forward"
              color="secondary"
              variant="filled"
              fab=""
            ></sy-button>
          )}
          {this?.highlights?.length
            ? this.highlights.map((preview) => (
                <sy-carousel-item key={preview._id}>
                  <sy-blog-highlights-card class="highlight" preview={preview} />
                </sy-carousel-item>
              ))
            : new Array(6).fill(0).map((_, i) => (
                <sy-carousel-item key={i}>
                  <sy-blog-highlights-card class="highlight" />
                </sy-carousel-item>
              ))}
        </sy-carousel>
      </Host>
    );
  }
}
